import { colors, fonts } from '@factorialco/deprecated-design-system'

export const buildTheme = () => ({
  textColor: colors.grey1000,
  fontSize: Number(fonts.sizes[200].split('px')[0]),
})
